import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    sidebarOpen: true,
    activeModal: null,            // modal ID string or null
    selectedRows: [],             // table row selections
    notificationPanelOpen: false,
    globalSearchOpen: false,
  },
  reducers: {
    toggleSidebar: (state) => { state.sidebarOpen = !state.sidebarOpen; },
    setSidebarOpen: (state, action) => { state.sidebarOpen = action.payload; },
    openModal: (state, action) => { state.activeModal = action.payload; },
    closeModal: (state) => { state.activeModal = null; },
    setSelectedRows: (state, action) => { state.selectedRows = action.payload; },
    clearSelectedRows: (state) => { state.selectedRows = []; },
    toggleNotificationPanel: (state) => {
      state.notificationPanelOpen = !state.notificationPanelOpen;
    },
    toggleGlobalSearch: (state) => {
      state.globalSearchOpen = !state.globalSearchOpen;
    },
  },
});

export const {
  toggleSidebar, setSidebarOpen,
  openModal, closeModal,
  setSelectedRows, clearSelectedRows,
  toggleNotificationPanel,
  toggleGlobalSearch,
} = uiSlice.actions;

export default uiSlice.reducer;

export const selectSidebarOpen = (state) => state.ui.sidebarOpen;
export const selectActiveModal = (state) => state.ui.activeModal;
export const selectSelectedRows = (state) => state.ui.selectedRows;
export const selectNotificationPanelOpen = (state) => state.ui.notificationPanelOpen;
export const selectGlobalSearchOpen = (state) => state.ui.globalSearchOpen;
